<template>
  <div class="header">
    <div class="header-wrapper">
      <div class="header-content container">
        <div class="">
          <div class="logo pull-left">
            <img src="@/assets/images/logo.png" alt="云蜂树智" />
          </div>
          <div class="nav pull-left">
            <ul>
              <li v-for="(item) in navigation" :key="item.name">
                <router-link :to="item.path" v-if="item.path">{{item.name}}
                  <template v-if="item.children && item.children.length">
                    <img class="arrow" src="@/assets/images/r_icon_triangle_n.png">
                    <img class="arrow active" src="@/assets/images/r_icon_triangle_s.png">
                  </template>
                </router-link>
                <a href="javascript:void(0);" v-else>
                  <template v-if="item.children && item.children.length">{{item.name}}
                    <img class="arrow" src="@/assets/images/r_icon_triangle_n.png">
                    <img class="arrow active" src="@/assets/images/r_icon_triangle_s.png">
                  </template>
                </a>
                <div class="children" v-if="item.children && item.children.length">
                  <template v-for="(childItem, childIndex) in item.children" :key="childIndex">
                    <router-link
                      :to="childItem.path"
                      v-if="childItem.path"
                    >{{childItem.name}}</router-link>
                    <a href="javascript:void(0);" v-else>
                      <template v-if="item.children && item.children.length">{{childItem.name}} </template>
                    </a>
                  </template>
                </div>
              </li>
            </ul>
          </div>
          <!-- <div class="deck pull-right">
            <div class="deck-btn" @click="handleConsole">控制台</div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navigation } from '@/core/dataCommon';

export default {
  name: 'Header',
  props: {},
  data() {
    return {
      navigation
    };
  },
  methods: {
    handleConsole() {
      const { href } = this.$router.resolve({
        path: '/console',
      });
      window.open(href, '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.header{
  height: 80px;
  .header-wrapper{
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    border-bottom: 1px solid #e4e4e4;
  }
  .header-content{
  }
  .logo{
    margin-top: 17px;
    img{
      width: 180px;
      height: 46px;
    }
  }
  .nav{
    margin-left: 10%;
    ul{
      display: flex;
      li{
        position: relative;
        box-sizing: border-box;
        height: 80px;
        & > a{
          display: flex;
          align-items: center;
          color: #282839;
          font-weight: bold;
          font-size: 16px;
          line-height: 78px;
          box-sizing: border-box;
          .arrow{
            width: 12px;
            height: 7px;
            margin-left: 6px;
            transition: all .3s;
            &.active{
              display: none;
              transform: rotate(180deg);
            }
          }
          &.router-link-exact-active{
            color: $color-primary;
            border-bottom: 3px solid $color-primary;
          }
        }
        &:hover{
          & > a{
            color: $color-primary;
            border-bottom: 3px solid $color-primary;
          }
          .arrow{
            display: none;
            &.active{
              display: block;
            }
          }
          .children{
            display: block;
          }
        }
        & + li{
          margin-left: 60px;
        }
      }
      .children{
        display: none;
        position: absolute;
        left: 0;
        background: #fff;
        box-shadow: 0 2px 6px rgba(0,0,0,.3);
        overflow: hidden;
        padding: 8px 0;
        color: #333333;
        a{
          display: block;
          padding: 0 10px;
          font-size: 14px;
          font-weight: bold;
          white-space: nowrap;
          line-height: 44px;
          &.router-link-exact-active{
            color: $color-primary !important;
          }
          &:hover{
            background-color: #ECECEE;
            color: #333333;
          }
        }
      }
    }
  }
  .deck{
    .deck-btn{
      font-size: 16px;
      color: $color-primary;
      line-height: 30px;
      border-radius: 4px;
      width: 90px;
      text-align: center;
      border: 1px solid $color-primary;
      margin-top: 25px;
      cursor: pointer;
    }
  }
}
</style>
